export default "__VITE_ASSET__sFa9_Fyx__"